// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2XqP9","title":"Info_title__29vnC","links":"Info_links__2YECJ","link":"Info_link__3BGxK","logo":"Info_logo__3YrWX"};